// extracted by mini-css-extract-plugin
export default {"category_container":"category_category_container__fdaoH","category_box":"category_category_box__qlAwP","img_container":"category_img_container__wxk4p"};